import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-layout-2",
  "use": "icon-si-glyph-layout-2-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-layout-2\" id=\"icon-si-glyph-layout-2\"><title>1206</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><path d=\"M16,16 L0.021,16 L0.021,0.042 L16,0.042 L16,16 L16,16 Z M14.958,15.043 L14.958,1 L0.958,1 L0.958,15.043 L14.958,15.043 Z\" class=\"si-glyph-fill\" /><rect x=\"2\" y=\"2\" width=\"5\" height=\"12\" class=\"si-glyph-fill\" /><rect x=\"9\" y=\"2\" width=\"5\" height=\"12\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-layout-2.svg
// module id = 66yN
// module chunks = 62